import { ProfiBazaAPIModels } from 'services/src/profiBazaAPI';

export const mappings = new Map<ProfiBazaAPIModels.SubjectCommentType, string>([
	[ProfiBazaAPIModels.SubjectCommentType.IMPORTANT, 'ważny'],
	[ProfiBazaAPIModels.SubjectCommentType.PRIVATE, 'Informacyjny w ramach podmiotu'],
	[ProfiBazaAPIModels.SubjectCommentType.PUBLIC, 'informacyjny publiczny'],
]);

export const map = (value: ProfiBazaAPIModels.SubjectCommentType): string =>
	mappings.get(value) ?? '';